import api from '@/api/services/api'

const getTransfers = params => api({
  method: 'get',
  url: '/autocomplete/transfers',
  params
})

const getAvia = params => api({
  method: 'get',
  url: '/autocomplete/flights',
  params
})

const getHotelsPlaces = params => api({
  method: 'get',
  url: '/autocomplete/hotels/places',
  params
})

const getHotelsCountries = params => api({
  method: 'get',
  url: '/autocomplete/hotels/countries',
  params
})

const getHotelsRegions = params => api({
  method: 'get',
  url: '/autocomplete/hotels/regions',
  params
})

const getHotelsHotels = params => api({
  method: 'get',
  url: '/autocomplete/hotels/hotels',
  params
})

const getExcursionsPlaces = params => api({
  method: 'get',
  url: '/autocomplete/excursions',
  params
})

const getToursOrigins = params => api({
  method: 'get',
  url: '/autocomplete/tours/origin/places',
  params
})

const getToursPlaces = params => api({
  method: 'get',
  url: '/autocomplete/tours/destination/places',
  params
})

const getToursCountries = params => api({
  method: 'get',
  url: '/autocomplete/tours/destination/countries',
  params
})

const getToursRegions = params => api({
  method: 'get',
  url: '/autocomplete/tours/destination/regions',
  params
})

const getToursHotels = params => api({
  method: 'get',
  url: '/autocomplete/tours/destination/hotels',
  params
})

const getFitCountries = params => api({
  method: 'get',
  url: '/autocomplete/fit/countries',
  params
})

const getFitCountryCities = params => api({
  method: 'get',
  url: '/autocomplete/fit/cities',
  params
})

export {
  getTransfers,
  getAvia,
  getHotelsPlaces,
  getHotelsCountries,
  getHotelsRegions,
  getHotelsHotels,
  getExcursionsPlaces,
  getToursOrigins,
  getToursPlaces,
  getToursCountries,
  getToursRegions,
  getToursHotels,
  getFitCountries,
  getFitCountryCities
}